export const ATTEMPT_LOGIN = 'ATTEMPT_LOGIN';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT = 'LOGOUT';

export const BLOCK_NAVIGATION = 'BLOCK_NAVIGATION'

export const MODAL_CREATE_TYPE = 'MODAL_CREATE_TYPE'

export const UPDATE_PROFILE = 'UPDATE_PROFILE'